import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectInterface } from '../../../../sdk/type';
import { Button, ButtonSize, ButtonStyles, ButtonTypes, Modal, Theme } from '../../../../ui/components';
import SuccessBG from '../../../../assets/image/illustrations/success.svg';
import styles from './SuccessModal.module.scss';

interface SuccessModalProps {
  onClose: DynamicObjectInterface;
  data: Campaign;
}

interface Campaign {
  name: string;
}

export const SuccessModal = ({ onClose, data }: SuccessModalProps) => {
  const { t } = useTranslation();

  const [campaignInfo, setCampaignInfo] = useState<Campaign>(data);

  useEffect(() => {
    // Setting up data
    setCampaignInfo(data);
  }, [data]);

  return (
    <Modal
      primaryButtonLabel={''}
      headline={''}
      onClose={onClose}
      closeIcon={true}
      containerWidth="383px"
      containerHeight="413px"
    >
      <div className={styles['modal-success-registration']}>
        <div className={styles['modal-success-box']}>
          <img src={SuccessBG} alt="success" />

          <div className={styles['modal-success-box-content']}>
            <div className={styles['modal-success-box-title']}>
              {t('dashboard.join-team.register.modal.successfulRegistrationTitle')}
            </div>
            <div className={styles['modal-success-box-desc']}>
              {t('dashboard.join-team.register.modal.successfulRegistrationDesc')?.replace(
                '{campaign-name}',
                campaignInfo?.name || '',
              )}
            </div>

            <div className={styles['modal-success-box-button']}>
              <Button
                title={t('dashboard.join-team.register.modal.button.letsGo')}
                type={ButtonTypes.BUTTON}
                onClick={() => {
                  onClose();
                }}
                style={{ padding: '18px 44px' }}
                theme={Theme.GREEN}
                size={ButtonSize.SMALL}
                buttonStyle={ButtonStyles.SOLID}
                data-testid="test-cta-button-popup"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
